import { Box, Container, Typography, Button, styled } from "@mui/material";

export const NotFoundBox = styled(Box)({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    height: 'calc(100vh - 64px)',
    padding: '24px'
});

export const NotFoundContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    padding: '2rem',
    paddingTop: '5rem',
    [theme.breakpoints.down('md')]: {
        padding: '1rem',
        paddingTop: '3rem'
    }
}));

export const NotFoundTitle = styled(Typography)(({ theme }) => ({
    fontSize: '8rem',
    fontWeight: 700,
    color: '#0058A0',
    marginBottom: '1rem',
    lineHeight: 1,
    [theme.breakpoints.down('md')]: {
        fontSize: '4rem'
    }
}));

export const NotFoundHeading = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginBottom: '1rem',
    fontSize: '2rem',
    [theme.breakpoints.down('md')]: {
        fontSize: '1.5rem'
    }
}));

export const NotFoundDescription = styled(Typography)({
    color: '#666',
    marginBottom: '2rem',
    maxWidth: '600px'
});

export const NotFoundButton = styled(Button)({
    backgroundColor: '#0058A0',
    padding: '0.75rem 2rem',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: '#153366',
        boxShadow: 'none',
    }
}); 